export const updateKommentarInInhaltselement = (updatedKommentar, inhaltsElement, setInhaltselement) => {
    const filteredKommentare = inhaltsElement.kommentare.filter(kommentar => kommentar.id !== updatedKommentar.id);
    setInhaltselement({ ...inhaltsElement, kommentare: [...filteredKommentare, updatedKommentar] });
};

export const deleteKommentarInInhaltselement = (deletedKommentar, inhaltselement, setInhaltselement) =>
    setInhaltselement({ ...inhaltselement, kommentare: inhaltselement.kommentare.filter(kommentar => kommentar.id !== deletedKommentar.id) });
